/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import ConstantsModel from 'astro/server/constants';

import ProjectilesState from 'astro/fake/state/constants/projectiles';
import SpaceshipsState from 'astro/fake/state/constants/spaceships';
import EntitiesState from 'astro/fake/state/constants/entities';
import BuildingsState from 'astro/fake/state/constants/buildings';
import UnitsState from 'astro/fake/state/constants/units';

import ThemesState from 'astro/fake/state/constants/themes';


export default (constants) =>
{
  let state = new Immutable.Map();

  state = state.set('projectiles', ProjectilesState(constants.getProjectiles()));
  state = state.set('spaceships', SpaceshipsState(constants.getSpaceships()));
  state = state.set('entities', EntitiesState(constants.getEntities()));
  state = state.set('buildings', BuildingsState(constants.getBuildings()));
  state = state.set('units', UnitsState(constants.getUnits()));

  state = state.set('themes', ThemesState(constants.getThemes()));

  return new ConstantsModel(state, null);
}

